import React from "react";

import { useTranslation } from "react-i18next";

import { ReactComponent as HamburgerIcon } from "../../../media/icons/hamburger.svg";
import styles from "./hamburger.module.css";

export const Hamburger = ({ toggleDropdown, activeMenu, large = false }) => {
  const { t } = useTranslation();

  return (
    <button
      className={large ? `${styles.hamburger} ${styles.hamburgerLarge}` : styles.hamburger}
      type="button"
      onClick={toggleDropdown}
      aria-label={t("dashboard_main_menu_open")}
      aria-expanded={Boolean(activeMenu)}
      aria-controls="main-sidebar"
    >
      <HamburgerIcon aria-hidden="true" />
    </button>
  );
};
